import { render } from "./FranchiseAdmin.vue?vue&type=template&id=059fe71c"
import script from "./FranchiseAdmin.vue?vue&type=script&lang=js"
export * from "./FranchiseAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__